module.exports = {
      id: "icon-stats-stats-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-stats-stats",
      toString: function () {
        return this.url;
      }
    }